import { useCallback, useState } from "react";
import { FormInput, common } from "@k8slens/lds-form";
import { Button } from "@k8slens/lds";
import { businessHandleValidation } from "lens-platform-sdk";

import { useAnalytics } from "src/hooks/useAnalytics";

import formStyles from "src/components/styles/form.module.css";
import Notification from "src/components/Notification/Notification";

import styles from "./SignIn.module.css";

const SSOSignIn: React.FC<{
  formClassName?: string;
  footerClassName?: string;
  onSSOLogin: (businessHandle: string) => Promise<unknown>;
  onCancel: () => void;
}> = ({ formClassName, footerClassName, onSSOLogin, onCancel }) => {
  const ssoLoginLabel = "Continue";
  const ssoCancelLabel = "← Back";

  const { trackButtonClicked } = useAnalytics();

  const [businessHandle, setBusinessHandle] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const onBusinessHandleChange = useCallback(
    (handle: string, inputIsValid: boolean) => {
      setIsValid(handle ? inputIsValid : false);
      setBusinessHandle(handle);
    },
    [setBusinessHandle, setIsValid],
  );

  const handleCancelClick = useCallback(() => {
    trackButtonClicked(ssoCancelLabel);
    setBusinessHandle("");
    onCancel();
  }, [trackButtonClicked, onCancel]);

  const handleLoginClick = useCallback(() => {
    setError(null);

    if (!isValid) {
      setError(new Error("Please enter a valid Lens Business ID"));

      return Promise.resolve(false);
    }

    trackButtonClicked(ssoLoginLabel);

    return onSSOLogin(businessHandle).catch((err) => {
      setError(err);
    });
  }, [isValid, trackButtonClicked, businessHandle, onSSOLogin, setError]);

  return (
    <>
      {error && <Notification type="flash" level="error" message={error?.message} onClose={() => setError(null)} />}
      <div className={formClassName}>
        <FormInput
          id="business-handle"
          name="business-handle"
          label="Lens Business ID"
          pattern={businessHandleValidation.source}
          value={businessHandle}
          onChange={onBusinessHandleChange}
          errorParser={common.defaultErrorParser}
        />
      </div>
      <div className={footerClassName}>
        <div className={formStyles.btnThreeSideBySide}>
          <button className={styles.backButton} type="button" onClick={handleCancelClick}>
            {ssoCancelLabel}
          </button>
          <div />
          <Button
            type="primary"
            label={ssoLoginLabel}
            onClick={handleLoginClick}
            loadingStateOnPromise
            disabled={!isValid}
          />
        </div>
      </div>
    </>
  );
};

export default SSOSignIn;
